module.exports = __webpack_public_path__ + "img/favorite.5e98fd7f.png";